import Model from "../classes/Model";
import TrainerApi from '../classes/api/Trainer';
import ValidationError from "../classes/ValidationError";

export default class Trainer extends Model {

    get status() {
        return this._status;
    }
    set status(value) {
        this._status = value;
    }

    get firstName() {
        return this._firstName;
    }
    set firstName(value) {
        this._firstName = value;
    }
    get lastName() {
        return this._lastName;
    }
    set lastName(value) {
        this._lastName = value;
    }
    get fullName() {
        let pieces = [];
        if (this.firstName) {
            pieces.push(this.firstName);
        }
        if (this.lastName) {
            pieces.push(this.lastName);
        }
        return pieces.join(' ');
    }
    get content() {
        return this._content;
    }

    set content(value) {
        this._content = value;
    }
    get image() {
        return this._image;
    }
    set image(value) {
        this._image = value;
    }
    get isArchive() {
        return this._isArchive;
    }
    set isArchive(value) {
        this._isArchive = value;
    }
    get isShowSite() {
        return this._isShowSite;
    }
    set isShowSite(value) {
        this._isShowSite = value;
    }

    get id() {
        return this._id;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            first_name: this.firstName,
            last_name: this.lastName,
            content: this.content,
            status: this.status === true ? this.STATUS_ACTIVE : this.STATUS_DISABLED,
            is_archive: this.isArchive ? 1 : 0,
            is_show_site: this.isShowSite ? 1 : 0,
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            firstName: data.first_name,
            lastName: data.last_name,
            content: data.content,
            status: data.status === this.STATUS_ACTIVE,
            image: {
                image: data.image,
                small: data.image_small,
            },
            isArchive: data.is_archive,
            isShowSite: data.is_show_site,
        };
    }

    static getList(page = 1, perPage = 10, sort = undefined) {
        return TrainerApi.getList(page, perPage, sort).then((response) => {
            let data = [];
            for (let trainer of response.data) {
                data.push(new this(this.toResponse(trainer)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return TrainerApi.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return TrainerApi.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new Trainer(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return TrainerApi.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    updateImage(file) {
        return TrainerApi.updateImage(this.id, file).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            this.image.image = data.image;
            this.image.small = data.image_small;
            return true;
        });
    }

}